/**
 * member-list.js
 */

import React from 'react';
import { Typography, IconButton, List, ListItem, Divider, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from 'components/icon';
import GroupMember from './group-member';


const useStyles = makeStyles(theme => ({
  userList: {
    marginTop: theme.spacing(2),
    maxWidth: 450,
    '& li .action': {
      margin: `0 ${theme.spacing(0.5)}`
    }
  },
  header: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: theme.spacing(0.25),
    color: theme.palette.sys.onSurfaceVariant,
    textTransform: 'uppercase',
    '& .primary-content': {
      flex: 1, 
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    }
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
}));


const RemoveButton = (props) => {
  const { tooltipTitle, disabled, onClick } = props;

  return (
    <Tooltip
      arrow
      placement='top'
      title={tooltipTitle}
    >
      <span>
        <IconButton 
          size='small' 
          className='remove' 
          disabled={disabled}
          onClick={onClick}
          children={<Icon type='close' />}
        />
      </span>
    </Tooltip>
  );
}


export default function MemberList(props) {
  const {
    headerLabels,
    members,
    onChange,
    canRemove,
    removeResultReason,
    userColExtra,
    renderers,
  } = props;
  const classes = useStyles();


  const onRemoveMember = (member) => {
    const newMembers = members.filter(m => m.id !== member.id);
    onChange(newMembers);
  }


  if (!members || members.length === 0) {
    return null;
  }

  return (
    <>
      <List className={classes.userList}>

        {/* HEADER */}
        <ListItem dense classes={{ root: `${classes.header}` }} className='member-list-header'>
          <div className={'flex-hc primary-content'}>
            <Typography variant='caption'>{headerLabels[0]}</Typography>
          </div>
          {headerLabels.slice(1).map((label, i) => (
            <Typography key={i} variant='caption' className='action'>{label}</Typography>
          ))}
        </ListItem>

        <Divider className={classes.divider} />

        {/* MEMBERS */}
        {members?.map((member, i) => (
          <GroupMember
            key={`${member.id}-${i}`}
            icon={<RemoveButton
              tooltipTitle={removeResultReason?.(member) || 'Remove this member from the group'}
              disabled={canRemove?.(member) === false}
              onClick={() => onRemoveMember(member)}
            />}
            member={member}
            memberExtra={userColExtra?.(member) || ''}
            actions={renderers?.map((r, i) => <span key={i} className='action'>{r(member)}</span>)}
          />
        ))}

      </List>
    </>
  );
}